<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Airline List",
      items: [
        {
          text: "Airline",
          href: "/",
        },
        {
          text: "Airline List",
          active: true,
        },
      ],
      airlines: [],
        visible:false,
        errors: null,
        message:"",
        search_name:"",
        search_code:"",

    };
  },
  mounted() {
    this.getAirlineList();
  },
    computed: {
        filteredList() {
            return this.airlines.filter(airline => {
                return airline.name.toLowerCase().includes(this.search_name.toLowerCase())
                    && airline.code.toLowerCase().includes(this.search_code.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
    async getAirlineList() {
      try {
        axios
          .get("/api/airline/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.airlines = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
          this.visible=true;
          this.message="Access Permission Denied";
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    async deleteWarning(airline) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(airline);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(airline) {
      var _this = this;
      axios
        .post("/api/airline/delete/" + airline.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if (response.data.status) {
                _this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Successfully Delete Airline',
                    showConfirmButton: false,
                    timer: 1000
                });
                _this.getAirlineList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title">Responsive tables</h4>-->
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                    <td><input type="text" class="app-search form-control" v-model="search_name" placeholder="Search by name" /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_code" placeholder="Search by code" /></td>
                    <td> </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(airline,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{airline.name}}</td>
                    <td>{{airline.code}}</td>
                    <td><router-link :to="{ name: 'airline_update', params: {id: airline.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(airline)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
